export type { InfoBadgesProps } from "./info-badges";
export { InfoBadges } from "./info-badges";
